import { faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Select, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import dataTypeMergeRules from "./MergeRuleDataTypes.json";
import mergeRuleDataTypeTooltips from "./MergeRuleDataTypeTooltip.json";

const { Column } = Table;
const { Option } = Select;

const RuleTypeSelection = ({ value, onChange, rules, field, formRef, onSelectNominatedValueClick }) => {
    const [ruleValue, setRuleValue] = useState(value || rules[0].value);

    useEffect(() => {
        setRuleValue(value);
    }, [value]);

    const onRuleChange = React.useCallback(
        (selectedValue) => {
            onChange(selectedValue);
        },
        [onChange],
    );

    const onSelectValueClick = React.useCallback(() => {
        onSelectNominatedValueClick(
            field,
            formRef.current.getFieldValue(["rules", field.name, "nominatedValue"]),
            formRef.current.getFieldValue(["rules", field.name, "fieldName"]),
        );
    }, [field, formRef, onSelectNominatedValueClick]);

    const dataType = React.useMemo(() => formRef.current?.getFieldValue(["rules", field.name, "fieldDataType"]), [field.name, formRef]) ?? "";

    return (
        <div className="flex gap-2">
            <Select
                showSearch
                onChange={onRuleChange}
                value={ruleValue}
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
                {rules.map((rule) => (
                    <Option key={rule.value} value={rule.value} className="w-full">
                        <Tooltip
                            destroyOnHidden
                            placement="left"
                            title={rule.value in mergeRuleDataTypeTooltips ? mergeRuleDataTypeTooltips[rule.value].replace("{type}", dataType) : null}
                            className="block"
                        >
                            {rule.name}
                        </Tooltip>
                    </Option>
                ))}
            </Select>
            {value === "NOMINATED_VALUE" && (
                <Tooltip title="Click to select a value">
                    <Button onClick={onSelectValueClick}>
                        <FontAwesomeIcon icon={faList} style={{ color: "#3881ff" }} />
                    </Button>
                </Tooltip>
            )}
        </div>
    );
};

const DataObjectDuplicateMergeRuleList = ({ formRef, rules, onSelectNominatedValueClick }) => {
    return (
        <Table size="small" dataSource={rules} pagination={false}>
            <Column
                width="10%"
                title={"No."}
                key="index"
                render={(value, field, index) => {
                    return index + 1;
                }}
            />
            <Column
                dataIndex={"fieldName"}
                title={"Field Name"}
                ellipsis={{
                    showTitle: false,
                }}
                render={(value, field, index) => {
                    return (
                        <Form.Item {...field}>
                            <>{formRef.current && formRef.current.getFieldValue(["rules", field.name, "fieldName"])}</>
                        </Form.Item>
                    );
                }}
            />
            <Column
                width="20%"
                dataIndex={"fieldDataType"}
                title={"Data Type"}
                ellipsis={{
                    showTitle: false,
                }}
                render={(value, field, index) => {
                    return (
                        <Form.Item {...field}>
                            <>{formRef.current && formRef.current.getFieldValue(["rules", field.name, "fieldDataType"])}</>
                        </Form.Item>
                    );
                }}
            />
            <Column
                width="50%"
                dataIndex={"rule"}
                title={"Rule"}
                ellipsis={{
                    showTitle: false,
                }}
                render={(value, field, index) => {
                    let rules = [];
                    let dataType = formRef.current && formRef.current.getFieldValue(["rules", field.name, "fieldDataType"]);
                    if (dataType) {
                        rules = dataTypeMergeRules[dataType] || [];
                    }
                    return (
                        <Form.Item {...field} name={[field.name, "rule"]} initialValue="string">
                            <RuleTypeSelection rules={rules} formRef={formRef} field={field} onSelectNominatedValueClick={onSelectNominatedValueClick}></RuleTypeSelection>
                        </Form.Item>
                    );
                }}
            />
        </Table>
    );
};

export default DataObjectDuplicateMergeRuleList;
